import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useSearchParams } from 'react-router-dom';
import './styles.css';
import SEO from '../../components/SEO';

export default function Login() {
  const { loginWithRedirect, isLoading, isAuthenticated } = useAuth0();
  const [searchParams] = useSearchParams();

  // Get returnTo parameter from URL
  const returnTo = searchParams.get('returnTo') || '/member-selection';

  // Immediately redirect to Auth0 login when component loads
  useEffect(() => {
    if (!isAuthenticated && !isLoading) {
      loginWithRedirect({
        appState: { returnTo: returnTo }
      });
    }
  }, [isAuthenticated, isLoading, loginWithRedirect, returnTo]);  

  // Show loading state while redirecting
  return (
    <>
      <SEO
        title="Login to EternaVaults - Access Your Digital Legacy Vault"
        description="Sign in to your EternaVaults account to access your secure digital legacy vault. Manage family memories, documents, and digital inheritance with bank-level security."
        keywords="eternavaults login, digital vault login, family vault access, secure login, digital legacy access, family cloud storage login, vault sign in, digital inheritance login"
        canonical="https://eternavaults.com/login"
        ogImage="/login-og-image.jpg"
        noIndex={true}
      />
      <div className="login-bg">
        <div className="login-container">
          <div className="login-brand">
            <h1>Eterna Vaults</h1>
            <p className="login-tagline">
              Legacy, Secured
            </p>
          </div>
          <div className="login-form" style={{ textAlign: 'center', padding: '2rem' }}>
            <h2>Redirecting to Sign In...</h2>
            <p style={{ color: '#bfa97a', marginTop: '1rem' }}>
              Please wait while we redirect you to the secure login page.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
